
import Vue from 'vue';
import Component from 'vue-class-component';
import MenuButton from '../MenuButton.vue';
import ChatList from './ChatList.vue';
import { getModule } from 'vuex-module-decorators';
import store from '../../store';
import ChatModule from '../../store/modules/Chat';
import { Prop, Watch } from 'vue-property-decorator';
import { createInterfaceSound, playInterfaceSound } from '@/service/interfaceSound';

const chatModule = getModule(ChatModule, store);

@Component({
    components: {
        MenuButton,
        ChatList
    }
})
export default class ChatWidget extends Vue {
    @Prop({ type: String, default: '' }) caption!: string;
    public widgetOpen: boolean = false;
    
    playSlideSound() {
        const audio = createInterfaceSound('/sound/slide.wav');
        playInterfaceSound(audio).catch(error => {
            console.log('Audio playback failed:', error);
        });
    }
    
    get unreadMessageCount() {
        return chatModule.chats.filter(c => c.messages.some(msg => !msg.isRead && msg.author !== 'me')).length;
    }
    
    @Watch('widgetOpen')
    onWidgetOpenChange(value: boolean) {
        if (value) {
            this.playSlideSound();
        }
    }
}
